import React from "react";
import styled from "styled-components";
import EmptyDataPeopleSvg from "core/images/empty_data_people.svg";
import EmptyDataSvg from "core/images/empty_data_smile.svg";
import EmptyDataTreeSvg from "core/images/empty-data/tree.svg";
import EmptyDataFileSvg from "core/images/empty-state/file.svg";
import { Breakpoints } from "core/constants";

const EmptyDataImgComp = (props: any) => {
  let imageSrc;

  switch (props.variant) {
    case "people":
      imageSrc = EmptyDataPeopleSvg;
      break;
    case "file":
      imageSrc = EmptyDataFileSvg;
      break;
    case "tree":
      imageSrc = EmptyDataTreeSvg;
      break;
    default:
      imageSrc = EmptyDataSvg;
      break;
  }

  return <img src={imageSrc} {...props} />;
};

export const Container = styled.div`
  min-height: 534px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: fit-content;

  margin: auto;

  @media screen and (max-width: ${Breakpoints.tablet}px) {
    width: 250px;
    p {
      font-size: 14px;
    }
  }
`;

export const EmptyDataImg = styled(EmptyDataImgComp)`
  margin-bottom: 32px;
`;
